import React, { useState, useEffect } from 'react';
import CompanyImg from '../../images/company.png';

const CampaignBarChart = props => {

  return (
    <div className="CampaignBarChart">
      <h2>{props.title}</h2>
      <div className="CampaignBarChart_more-info" onClick={()=>props.closeModal(true)}>More info</div>
      <div className="CampaignBarChart_top-title">
        <div>Top 5 (Over-indexing)</div>
        <div>Bottom 5 (Under-indexing)</div>
      </div>
      <div className="CampaignBarChart_container">
        <div className="CampaignBarChart_axis-line-area">
          <div className="CampaignBarChart_x-axis-title">1.75</div>
          <div className="CampaignBarChart_x-axis" />
          <div className="CampaignBarChart_x-axis-title">1.50</div>
          <div className="CampaignBarChart_x-axis" />
          <div className="CampaignBarChart_x-axis-title">1.25</div>
          <div className="CampaignBarChart_x-axis" />
          <div className="CampaignBarChart_x-axis-title">
            <strong>1.00</strong>
          </div>
          <div className="CampaignBarChart_x-axis_base" />
          <div className="CampaignBarChart_x-axis-title">0.75</div>
          <div className="CampaignBarChart_x-axis" />
          <div className="CampaignBarChart_x-axis-title">0.50</div>
          <div className="CampaignBarChart_x-axis" />
          <div className="CampaignBarChart_x-axis-title">0.25</div>
          <div className="CampaignBarChart_x-axis" />
        </div>

        <div className="CampaignBarChart_positive-bar-area">
          {props.data.map(item => (
            <div className="CampaignBarChart_positive-bar" />
          ))}
        </div>

        <div className="CampaignBarChart_negative-bar-area">
          {props.data.map(item => (
            <div className="CampaignBarChart_negative-bar" />
          ))}
        </div>

        <div className="CampaignBarChart_positive-img-area">
          {props.data.map(item => (
            <img src={CompanyImg} />
          ))}
        </div>

        <div className="CampaignBarChart_positive-title-area">
          {props.data.map(item => (
            <div className="CampaignBarChart_positive-titles">
              Skoda <strong>1.4x</strong>
            </div>
          ))}
        </div>

        <div className="CampaignBarChart_negative-img-area">
          {props.data.map(item => (
            <img src={CompanyImg} />
          ))}
        </div>

        <div className="CampaignBarChart_negative-title-area">
          {props.data.map(item => (
            <div className="CampaignBarChart_positive-titles">
              Skoda <strong>1.4x</strong>
            </div>
          ))}
        </div>

        <div className="CampaignBarChart_background-area" />
      </div>


    </div>
  );
};

export default CampaignBarChart;
